<template>
	<main class="main-wrapper flex-grow-1 with-footer">
		<div class="d-flex align-items-center ">
				<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
						{{$t('1101')}}
				</div>
			<div class="mgr-24 right-button">
				<button class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" tabindex="0" type="button" @click="gotoBack()" @keypress="gotoBack()">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-color-iconActive font-r">{{$t('3317')}}</span>
				</button>
			</div>
		</div>
		<div class="divider"></div>
		<!-- subtabs -->

		<div id="chat" class="container container--narrow mgt-30 pdb-50">
			<div id="chatContainer" class=" flex-grow-1 scroll-y bg-white" :class="{'pdl-0 pdr-0': $route.name === 'LearnViewQuestion'}">
				<div class="w-full pdb-34">
					<chat-list :listData="listData"></chat-list>
				</div>
			</div>
		</div>

		<infinite-loading :identifier="infiniteId" force-use-infinite-wrapper="#chatContainer" spinner="spiral" @infinite="fetchData">
			<div slot="no-more" class="t-color-white">
			</div>
			<div slot="no-results" class="t-color-white">
			</div>
			<div slot="spinner"></div>
		</infinite-loading>

		<div class="footer bg-white bottomStack">
			<div class="divider"></div>
				<div class="container container--narrow pdb-0 dkcontainer">
					<div class="d-flex align-items-center justify-content-between pdt-4 pdb-4">
						<chat-write
							:examineeId="examineeId"
							:learnId="learnId"
							:lessonId="lessonId"
							:questionId="questionId"
							:roomId="roomId"
							@updateListData="updateListData"
						></chat-write>
					</div>
				</div>
			<div class="divider-white"></div>
		</div>
	</main>
</template>

<script>
/**
 * 나의학습/시험 질문하기 - 메인 컴포넌트(my learn / exam question - main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import chatApi from '@/api/chatApi.js'
import ChatList from './ChatList.vue'
import ChatWrite from './ChatWrite.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
	components: {
		'chat-list': ChatList,
		'chat-write': ChatWrite,
		InfiniteLoading,
	},

	data() {
		return {
			learnId: null,
			lessonId: null,
			roomId: null,

			examineeId: null,
			questionId: null,

			entered: false,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			showExamListChat :false,
			infiniteId: +new Date(),
		}
	},

	mounted() {
		if((this.$route.meta.chatType === 'exam' && this.$route.meta.TabType === 'ExamList') ||
		this.$route.meta.chatType === 'lesson' && this.$route.meta.TabType === 'LearnList') {
      this.showExamListChat = true;
		} else {
			this.showExamListChat = false;
		}
		this.learnId = this.$route.params.learnId
		this.lessonId = this.$route.params.lessonId
	},

  watch: {
    $route(to, from) {
      console.log(to, from, ' ___to from data')
    }
  },

	methods: {
		gotoBack(){
			if(this.$route.query.tb > 0) {
				localStorage.setItem('Last_Route_tb', this.$route.params.questionId);
					// this.$router.go(-1)
			} else {
				localStorage.setItem('Last_Route_tb', '');
				// this.$router.go(-1)
			}
			
			this.$router.push({
				name: 'LearnView',
				params: {learnId: this.$route.params.learnId},
				query: {
					...this.$route.query,
					tab: 'ViewQuestion'
				}
			})
		},

		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1
		},

		setisQuestionAnsHandlerChild(){
      this.$emit('setisQuestionAnsHandler')
    },

		fetchData($state) {
			if (this.$route.meta.chatType === 'exam') {
				this.fetchExamChatData($state)
			} else {
				this.fetchLearnChatData($state)
			}
		},

		// set parameter for learn question
		setParamsLearn() {
			let params = {
				learnId: this.learnId,
				lessonId: this.lessonId,
				roomId: this.roomId,
				page: this.currentPage,
				size: 50,
				sort: 'id,desc'
			}
			return params
		},

		// set parameter for exam question
		setParamsExam() {
			let params = {
				examineeId: this.examineeId,
				questionId: this.questionId,
				roomId: this.roomId,
				page: this.currentPage,
				size: 50,
				sort: 'id,desc'
			}
			return params
		},

		moveScrollBottom() {
			let element = this.$refs.scrollBottom
			let options = {
				container: '#chatContainer',
				easing: 'ease-in'
			}
			this.$scrollTo(element, 100, options)
		},

		// update chatting list data
		updateListData(data) {
			this.listData.push(data)
			this.roomId = data.roomId
			this.moveScrollBottom()
		},

		// get chatting list data for exam
		fetchExamChatData($state) {
			this.examineeId = this.$route.params.examineeId
			this.questionId = this.$route.params.questionId

			let params = {
				examineeId: this.examineeId,
				questionId: this.questionId
			}

			chatApi.examChatroomQuestion(params).then((response) => {
				this.entered = response.data.data.entered
				this.roomId = response.data.data.id
				if (response.data.data.entered) {
					params = this.setParamsExam()

					if (this.totalPages >= this.currentPage) {
						chatApi.examChatroomChatList(params).then((response) => {
							let responseData = response.data.data
							this.currentPage++
							this.totalPages = responseData.totalPages
							this.listData.unshift(...responseData.content.reverse());

							if (responseData.content.length) {
								$state.loaded()
							}else {
								$state.complete()
							}

							chatApi.examChatroomChatRead(params).then((response) => {
							}).catch((err) => {

							})
						})
					}else {
						$state.complete()
					}
				}else {
					$state.complete()
				}

			}).catch((err) => {
			})
		},

		// get chatting list data for my learn
		fetchLearnChatData($state) {
			this.learnId = this.$route.params.learnId
			this.lessonId = this.$route.params.lessonId
			let params = {
				learnId: this.learnId,
				lessonId: this.lessonId
			}

			// get chatting room information
			chatApi.learnChatroomLesson(params).then((response) => {
				this.entered = response.data.data.entered
				this.roomId = response.data.data.id
				if (response.data.data.entered) {
					params = this.setParamsLearn()

					if (this.totalPages >= this.currentPage) {
						// get chatting list
						chatApi.learnChatroomChatList(params).then((response) => {
							let responseData = response.data.data
							this.currentPage++
							this.totalPages = responseData.totalPages
							this.listData.unshift(...responseData.content.reverse());

							if (responseData.content.length) {
								$state.loaded()
							}else {
								$state.complete()
							}
							// set readed
							chatApi.learnChatroomChatRead(params).then((response) => {}).catch((err) => {})
						})
					} else {
						$state.complete()
					}
				} else {
					$state.complete()
				}
			}).catch((err) => {})
		}
	}
}
</script>
